import { useState, useEffect } from 'react';
import { PRINTER_KEY } from '../../../utils/storageKeys';

export const usePrinterSelection = (availablePrinters, selectedPrinter, selectPrinter) => {
  const [printerModalOpen, setPrinterModalOpen] = useState(false);
  const [bridgeInstallModalOpen, setBridgeInstallModalOpen] = useState(false);
  const [autoPrintEnabled, setAutoPrintEnabled] = useState(false);
  const [shouldAutoPrint, setShouldAutoPrint] = useState(false);

  useEffect(() => {
    const savedPrinter = localStorage.getItem(PRINTER_KEY);
    if (savedPrinter && !selectedPrinter && availablePrinters.length > 0) {
      try {
        const parsed = JSON.parse(savedPrinter);
        const found = availablePrinters.find((p) => p.name === parsed.name);
        if (found) {
          selectPrinter(found);
        }
      } catch {}
    }
  }, [availablePrinters, selectedPrinter, selectPrinter]);

  const handleSelectPrinter = async (printer, autoprint = false) => {
    selectPrinter(printer);
    setAutoPrintEnabled(autoprint);
    setPrinterModalOpen(false);
    if (printer) {
      localStorage.setItem(PRINTER_KEY, JSON.stringify(printer));
    }
  };

  return {
    printerModalOpen,
    setPrinterModalOpen,
    bridgeInstallModalOpen,
    setBridgeInstallModalOpen,
    autoPrintEnabled,
    setAutoPrintEnabled,
    shouldAutoPrint,
    setShouldAutoPrint,
    handleSelectPrinter,
  };
};